// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Link = require("next/link").default;
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationsAndAlertsUtils = require("../common/notifications/NotificationsAndAlertsUtils.bs.js");
var AgentMatchLogTextsBuyerNeed_aml_graphql = require("../../__generated__/AgentMatchLogTextsBuyerNeed_aml_graphql.bs.js");
var AgentMatchLogTextsRentalNeed_aml_graphql = require("../../__generated__/AgentMatchLogTextsRentalNeed_aml_graphql.bs.js");
var AgentMatchLogTextsRentalProperty_aml_graphql = require("../../__generated__/AgentMatchLogTextsRentalProperty_aml_graphql.bs.js");
var AgentMatchLogTextsForSaleProperty_aml_graphql = require("../../__generated__/AgentMatchLogTextsForSaleProperty_aml_graphql.bs.js");

var convertFragment = AgentMatchLogTextsForSaleProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsForSaleProperty_aml_graphql.node, convertFragment, fRef);
}

var AmlFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentMatchLogTexts$PropertyMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use(props.aml);
  var agentId = NotificationsAndAlertsUtils.AgentId.useForSaleAgentId(aml.source.agentV2.fragmentRefs);
  var shouldShowPropertyDetails = UserSession.useShouldShowPropertyDetails(agentId);
  var agentText = NotificationsAndAlertsUtils.AgentText.useForSaleAgentText(aml.source.agentV2.fragmentRefs);
  var match = aml.event;
  var verb;
  switch (match.__typename) {
    case "BroadcastPropertyCreatedAMLEvent" :
    case "QuietPropertyCreatedAMLEvent" :
        verb = "added";
        break;
    case "__unselected" :
        verb = "-";
        break;
    default:
      verb = "updated";
  }
  var match$1 = aml.event;
  var matches;
  switch (match$1.__typename) {
    case "BroadcastPropertyCreatedAMLEvent" :
        var match$2 = match$1.matches;
        matches = match$2 !== undefined ? ({
              TAG: "Matches",
              _0: Core__Array.keepSome(Core__Array.keepSome(match$2.edges).map(function (e) {
                        return Core__Option.map(e.node.source.client, (function (v) {
                                      return v.fragmentRefs;
                                    }));
                      }))
            }) : ({
              TAG: "Matches",
              _0: []
            });
        break;
    case "ForSalePropertyEditedAMLEvent" :
        matches = {
          TAG: "ExistingAndNew",
          new: Core__Array.keepSome(Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  })),
          existing: Core__Array.keepSome(Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "ForSalePropertyRebroadcastedAMLEvent" :
        matches = {
          TAG: "ExistingAndNew",
          new: Core__Array.keepSome(Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  })),
          existing: Core__Array.keepSome(Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "QuietPropertyBroadcastedAMLEvent" :
        matches = {
          TAG: "ExistingAndNew",
          new: Core__Array.keepSome(Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  })),
          existing: Core__Array.keepSome(Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "QuietPropertyCreatedAMLEvent" :
        var match$3 = match$1.matches;
        matches = match$3 !== undefined ? ({
              TAG: "Matches",
              _0: Core__Array.keepSome(Core__Array.keepSome(match$3.edges).map(function (e) {
                        return Core__Option.map(e.node.source.client, (function (v) {
                                      return v.fragmentRefs;
                                    }));
                      }))
            }) : ({
              TAG: "Matches",
              _0: []
            });
        break;
    case "__unselected" :
        matches = {
          TAG: "Matches",
          _0: []
        };
        break;
    
  }
  var matchesText;
  var exit = 0;
  var client;
  var matches$1;
  if (matches.TAG === "Matches") {
    var matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      var client$1 = matches$2[0];
      client = client$1;
      exit = 1;
    }
  } else {
    var matches$3 = matches.new;
    var exit$1 = 0;
    var len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        var matches$4 = matches.existing;
        if (matches$4.length !== 1) {
          matches$1 = matches$4;
          exit = 2;
        } else {
          var client$2 = matches$4[0];
          client = client$2;
          exit = 1;
        }
      }
    } else {
      var client$3 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = client$3;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        var length = matches$3.length;
        var content = length.toString() + " more of your buyers";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content)
              }) : content;
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
    
  }
  switch (exit) {
    case 1 :
        var clientName = NotificationsAndAlertsUtils.ClientLabel.getLabel(client, withLinks);
        matchesText = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                "your buyer ",
                clientName
              ]
            });
        break;
    case 2 :
        var length$1 = matches$1.length;
        var content$1 = length$1.toString() + " of your buyers";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content$1)
              }) : content$1;
        break;
    
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                shouldShowPropertyDetails ? (
                    withLinks ? (
                        agentId !== undefined ? JsxRuntime.jsx(Link, {
                                href: "/agents/" + agentId,
                                children: Caml_option.some(agentText)
                              }) : "A TAN agent"
                      ) : agentText
                  ) : "A TAN agent",
                " " + verb + " a property that matches ",
                matchesText
              ]
            });
}

var PropertyMatchText = {
  AmlFragment: AmlFragment,
  make: AgentMatchLogTexts$PropertyMatchText
};

var convertFragment$1 = AgentMatchLogTextsRentalProperty_aml_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsRentalProperty_aml_graphql.node, convertFragment$1, fRef);
}

var AmlFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function AgentMatchLogTexts$RentalPropertyMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$1(props.aml);
  var agentId = NotificationsAndAlertsUtils.AgentId.useAgentId(aml.source.agent.fragmentRefs);
  var shouldShowPropertyDetails = UserSession.useShouldShowPropertyDetails(agentId);
  var agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  var match = aml.event;
  var verb;
  switch (match.__typename) {
    case "RentalPropertyCreatedAMLEvent" :
        verb = "added";
        break;
    case "RentalPropertyEditedAMLEvent" :
    case "RentalPropertyRebroadcastedAMLEvent" :
        verb = "updated";
        break;
    case "__unselected" :
        verb = "-";
        break;
    
  }
  var match$1 = aml.event;
  var mtches;
  switch (match$1.__typename) {
    case "RentalPropertyCreatedAMLEvent" :
        mtches = {
          TAG: "Matches",
          _0: Core__Array.keepSome(Core__Array.keepSome(match$1.matches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "RentalPropertyEditedAMLEvent" :
        mtches = {
          TAG: "ExistingAndNew",
          new: Core__Array.keepSome(Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  })),
          existing: Core__Array.keepSome(Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "RentalPropertyRebroadcastedAMLEvent" :
        mtches = {
          TAG: "ExistingAndNew",
          new: Core__Array.keepSome(Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  })),
          existing: Core__Array.keepSome(Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                    return Core__Option.map(e.node.source.client, (function (v) {
                                  return v.fragmentRefs;
                                }));
                  }))
        };
        break;
    case "__unselected" :
        mtches = {
          TAG: "Matches",
          _0: []
        };
        break;
    
  }
  var matchesText;
  var exit = 0;
  var client;
  var matches;
  if (mtches.TAG === "Matches") {
    var matches$1 = mtches._0;
    if (matches$1.length !== 1) {
      matches = matches$1;
      exit = 2;
    } else {
      var client$1 = matches$1[0];
      client = client$1;
      exit = 1;
    }
  } else {
    var matches$2 = mtches.new;
    var exit$1 = 0;
    var len = matches$2.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        var match$2 = mtches.existing;
        if (match$2.length !== 1) {
          exit$1 = 3;
        } else {
          var client$2 = match$2[0];
          client = client$2;
          exit = 1;
        }
      }
    } else {
      var client$3 = matches$2[0];
      if (mtches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = client$3;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (mtches.existing.length !== 0) {
        if (matches$2.length !== 0) {
          var length = matches$2.length;
          var content = length.toString() + " more of your clients";
          matchesText = withLinks ? JsxRuntime.jsx(Link, {
                  href: "/match_log/" + aml.databaseId,
                  children: Caml_option.some(content)
                }) : content;
        } else {
          matches = mtches.existing;
          exit = 2;
        }
      } else {
        matches = matches$2;
        exit = 2;
      }
    }
    
  }
  switch (exit) {
    case 1 :
        var clientName = NotificationsAndAlertsUtils.ClientLabel.getLabel(client, withLinks);
        matchesText = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                "your client ",
                clientName
              ]
            });
        break;
    case 2 :
        var length$1 = matches.length;
        var content$1 = length$1.toString() + " of your clients";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content$1)
              }) : content$1;
        break;
    
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                shouldShowPropertyDetails ? (
                    withLinks ? JsxRuntime.jsx(Link, {
                            href: "/agents/" + agentId,
                            children: Caml_option.some(agentText)
                          }) : agentText
                  ) : "A TAN agent",
                " " + verb + " a rental property that matches ",
                matchesText
              ]
            });
}

var RentalPropertyMatchText = {
  AmlFragment: AmlFragment$1,
  make: AgentMatchLogTexts$RentalPropertyMatchText
};

var convertFragment$2 = AgentMatchLogTextsBuyerNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsBuyerNeed_aml_graphql.node, convertFragment$2, fRef);
}

var AmlFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function AgentMatchLogTexts$BuyerNeedMatchText(props) {
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var aml = use$2(props.aml);
  var agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  var match = aml.event;
  var verb;
  switch (match.__typename) {
    case "BuyerNeedEditedAMLEvent" :
    case "QuietBuyerNeedBroadcastedAMLEvent" :
        verb = "updated";
        break;
    case "BroadcastBuyerNeedCreatedAMLEvent" :
    case "QuietBuyerNeedCreatedAMLEvent" :
        verb = agentText === "You" ? "have" : "has";
        break;
    case "__unselected" :
        verb = "-";
        break;
    
  }
  var match$1 = aml.event;
  var matches;
  switch (match$1.__typename) {
    case "BroadcastBuyerNeedCreatedAMLEvent" :
        matches = {
          TAG: "MatchesWithLocation",
          _0: Core__Array.keepSome(match$1.matches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "BuyerNeedEditedAMLEvent" :
        matches = {
          TAG: "ExistingAndNewWithLocation",
          new: Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              }),
          existing: Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "QuietBuyerNeedBroadcastedAMLEvent" :
        matches = {
          TAG: "ExistingAndNewWithLocation",
          new: Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              }),
          existing: Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "QuietBuyerNeedCreatedAMLEvent" :
        matches = {
          TAG: "MatchesWithLocation",
          _0: Core__Array.keepSome(match$1.matches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "__unselected" :
        matches = {
          TAG: "MatchesWithLocation",
          _0: []
        };
        break;
    
  }
  var matchesText;
  var exit = 0;
  var client;
  var $$location;
  var matches$1;
  if (matches.TAG === "MatchesWithLocation") {
    var matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      var match$2 = matches$2[0];
      client = match$2.client;
      $$location = match$2.location;
      exit = 1;
    }
  } else {
    var matches$3 = matches.new;
    var exit$1 = 0;
    var len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        var matches$4 = matches.existing;
        if (matches$4.length !== 1) {
          matches$1 = matches$4;
          exit = 2;
        } else {
          var match$3 = matches$4[0];
          client = match$3.client;
          $$location = match$3.location;
          exit = 1;
        }
      }
    } else {
      var match$4 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = match$4.client;
        $$location = match$4.location;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        var content = matches$3.length.toString() + " more of your sellers";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content)
              }) : content;
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
    
  }
  switch (exit) {
    case 1 :
        matchesText = Core__Option.getOr(Core__Option.map(client, (function (c) {
                    return NotificationsAndAlertsUtils.ClientLabel.getLabel(c, withLinks);
                  })), NotificationsAndAlertsUtils.PropertyLocationLabel.getLabel($$location, withLinks));
        break;
    case 2 :
        var content$1 = matches$1.length.toString() + " of your sellers";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content$1)
              }) : content$1;
        break;
    
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                agentText,
                " " + verb + " a buyer that matches ",
                matchesText
              ]
            });
}

var BuyerNeedMatchText = {
  AmlFragment: AmlFragment$2,
  make: AgentMatchLogTexts$BuyerNeedMatchText
};

var convertFragment$3 = AgentMatchLogTextsRentalNeed_aml_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(AgentMatchLogTextsRentalNeed_aml_graphql.node, convertFragment$3, fRef);
}

var AmlFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function AgentMatchLogTexts$RentalNeedMatchText(props) {
  var __mode = props.mode;
  var __withLinks = props.withLinks;
  var withLinks = __withLinks !== undefined ? __withLinks : false;
  var mode = __mode !== undefined ? __mode : "Notifications";
  var aml = use$3(props.aml);
  var agentText = NotificationsAndAlertsUtils.AgentText.useAgentText(aml.source.agent.fragmentRefs, withLinks);
  var match = aml.event;
  var verb;
  switch (match.__typename) {
    case "RentalNeedCreatedAMLEvent" :
        verb = agentText === "You" ? "have" : "has";
        break;
    case "RentalNeedEditedAMLEvent" :
        verb = mode === "Alerts" ? "has a renter" : "updated a client";
        break;
    case "__unselected" :
        verb = "-";
        break;
    
  }
  var match$1 = aml.event;
  var matches;
  switch (match$1.__typename) {
    case "RentalNeedCreatedAMLEvent" :
        matches = {
          TAG: "MatchesWithLocation",
          _0: Core__Array.keepSome(match$1.matches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "RentalNeedEditedAMLEvent" :
        matches = {
          TAG: "ExistingAndNewWithLocation",
          new: Core__Array.keepSome(match$1.newMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              }),
          existing: Core__Array.keepSome(match$1.existingMatches.edges).map(function (e) {
                return {
                        client: Core__Option.map(e.node.source.client, (function (v) {
                                return v.fragmentRefs;
                              })),
                        location: e.node.source.fragmentRefs
                      };
              })
        };
        break;
    case "__unselected" :
        matches = {
          TAG: "MatchesWithLocation",
          _0: []
        };
        break;
    
  }
  var matchesText;
  var exit = 0;
  var client;
  var $$location;
  var matches$1;
  if (matches.TAG === "MatchesWithLocation") {
    var matches$2 = matches._0;
    if (matches$2.length !== 1) {
      matches$1 = matches$2;
      exit = 2;
    } else {
      var match$2 = matches$2[0];
      client = match$2.client;
      $$location = match$2.location;
      exit = 1;
    }
  } else {
    var matches$3 = matches.new;
    var exit$1 = 0;
    var len = matches$3.length;
    if (len !== 1) {
      if (len !== 0) {
        exit$1 = 3;
      } else {
        var match$3 = matches.existing;
        if (match$3.length !== 1) {
          exit$1 = 3;
        } else {
          var match$4 = match$3[0];
          client = match$4.client;
          $$location = match$4.location;
          exit = 1;
        }
      }
    } else {
      var match$5 = matches$3[0];
      if (matches.existing.length !== 0) {
        exit$1 = 3;
      } else {
        client = match$5.client;
        $$location = match$5.location;
        exit = 1;
      }
    }
    if (exit$1 === 3) {
      if (matches.existing.length !== 0) {
        if (matches$3.length !== 0) {
          var content = matches$3.length.toString() + " more of your clients";
          matchesText = withLinks ? JsxRuntime.jsx(Link, {
                  href: "/match_log/" + aml.databaseId,
                  children: Caml_option.some(content)
                }) : content;
        } else {
          matches$1 = matches.existing;
          exit = 2;
        }
      } else {
        matches$1 = matches$3;
        exit = 2;
      }
    }
    
  }
  switch (exit) {
    case 1 :
        matchesText = Core__Option.getOr(Core__Option.map(client, (function (c) {
                    return NotificationsAndAlertsUtils.ClientLabel.getLabel(c, withLinks);
                  })), NotificationsAndAlertsUtils.PropertyLocationLabel.getLabel($$location, withLinks));
        break;
    case 2 :
        var content$1 = matches$1.length.toString() + " of your clients";
        matchesText = withLinks ? JsxRuntime.jsx(Link, {
                href: "/match_log/" + aml.databaseId,
                children: Caml_option.some(content$1)
              }) : content$1;
        break;
    
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                agentText,
                " " + verb + " that matches ",
                matchesText
              ]
            });
}

var RentalNeedMatchText = {
  AmlFragment: AmlFragment$3,
  make: AgentMatchLogTexts$RentalNeedMatchText
};

exports.PropertyMatchText = PropertyMatchText;
exports.RentalPropertyMatchText = RentalPropertyMatchText;
exports.BuyerNeedMatchText = BuyerNeedMatchText;
exports.RentalNeedMatchText = RentalNeedMatchText;
/* next/link Not a pure module */
